/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateFormDataSchema = z.object({
	language: z.string(),
	questions: z.array(
		z.object({
			id: z.string().uuid().nullable(),
			label: z.string(),
			type: z.union([
				z.literal('select'),
				z.literal('text'),
				z.literal('open_text'),
				z.literal('file'),
				z.literal('datetime'),
			]),
			attribute: z.union([
				z.literal('name'),
				z.literal('email'),
				z.literal('phone'),
				z.literal('contact_consent'),
				z.literal('cv'),
				z.literal(null),
			]),
			subtype: z.union([
				z.literal('name'),
				z.literal('email'),
				z.literal('phone'),
				z.literal('multiple'),
				z.literal(null),
			]),
			validationRules: z.array(z.string()).nullable(),
			position: z.number(),
			options: z.array(
				z.object({
					id: z.string().nullable(),
					label: z.string(),
					position: z.number(),
					isDisqualifying: z.boolean().nullable().default(false),
					scoreValue: z.number().nullable(),
					consentType: z.string().nullable(),
				}),
			).nullable(),
			scores: z.array(z.object({ questionId: z.string().uuid(), optionId: z.string(), scoreValue: z.number() }))
				.nullable(),
			weight: z.number().nullable(),
		}),
	).nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type UpdateFormDataSchema = z.infer<typeof updateFormDataSchema>
